import "./index.css";
import { useTranslation } from "react-i18next";
import { Avatar, type IMenuItem, Menu, TruncatedContent } from "@/ui-kit";
import { useCallback, useMemo } from "react";
import { useAppStore } from "@/store/app/slice";
import { useNavigate } from "react-router";
import { ROUTES } from "@/router";
import { useBreakpoints } from "@/hooks/useBreakpoints";
import { UserLoadingStatus } from "@/types/users";

export const AvatarMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useAppStore((s) => s.user);
  const userLoaded = useAppStore((s) => s.userLoaded);
  const { isMobile } = useBreakpoints();

  const menuOptions: IMenuItem[] = useMemo(() => {
    return [
      {
        type: "element",
        element: (
          <div className="nuco-header__current-user">
            <TruncatedContent
              className="nuco-typography--body nuco-header__current-user-name"
              content={user?.fullName || ""}
            />
            <TruncatedContent
              className="nuco-typography--subtitle nuco-header__current-user-email"
              content={user?.email || ""}
            />
          </div>
        ),
      },
      {
        type: "divider",
        className: "nuco-header__current-user-divider",
      },
      {
        id: "settings",
        text: t("label.settings"),
      },
      {
        id: "switchTenant",
        text: t("label.switchTenant"),
      },
      {
        id: "legal",
        text: t("label.legal"),
      },
      {
        id: "logout",
        text: t("action.logout"),
      },
    ];
  }, [t, user]);

  const onMenuChange = useCallback(
    (id: string) => {
      if (id === "settings") {
        navigate(ROUTES.SETTINGS);
      }
      if (id === "switchTenant") {
        navigate(`/${ROUTES.SELECT_TENANT}`);
      }
      if (id === "legal") {
        navigate(`${ROUTES.LEGAL}/${ROUTES.PRIVACY_POLICY}`);
      }
      if (id === "logout") {
        navigate(`/${ROUTES.SIGN_OUT}`);
      }
    },
    [navigate],
  );

  if (isMobile) {
    return null;
  }

  return (
    <Menu
      options={menuOptions}
      onSelect={onMenuChange}
      maxWidth={240}
      minWidth={240}
      placement="bottom-end"
    >
      <Avatar
        data-testid="app-header-avatar"
        size="md"
        text={user?.fullName}
        src={user?.profilePicturePath}
        loading={userLoaded !== UserLoadingStatus.Loaded}
        showDetails={false}
        className="nuco-header__avatar-menu-button"
      />
    </Menu>
  );
};
